// MUST be the first import: captures & strips the auth token from the URL as a
// top-level side effect, before the router module is evaluated (createWebHistory
// snapshots window.location on evaluation). This keeps ?jwtToken=... out of the
// router's route state and the address bar. bootstrapAuth reuses the cached value.
import './utils/urlToken'

import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n.js'

import './main.css'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css';
import './styles/calendar/vcalendar.css';
import './styles/calendar/fullcalendar.css'
import './styles/calendar/dialog.css';
import './styles/font.css'
import './styles/workflow/dialogs/workflow-dialogs.css'
import 'vue-color/style.css';
import VAUIComponents from 'va-ui-components'
import VAResponsiveComponentsLibrary from '@vibrant-wellness/va-responsive-components-library'
import { Userpilot } from 'userpilot'


import { transSericeApolloClient } from './graphql'
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { createApolloProvider } from '@vue/apollo-option'

// Create and mount Vue app
// Bootstrap will be called in App.vue created hook
const app = createApp(App)

app.use(ElementPlus)
app.use(router)
app.use(store)
app.use(VCalendar)
app.use(VAUIComponents)
app.use(VAResponsiveComponentsLibrary)
app.use(i18n)

app.provide('image_base_url', "https://portalazblobstorage.blob.core.windows.net/va-portal/");

// Adds messages only in a dev environment
loadDevMessages();
loadErrorMessages();
// Provide Apollo Clients to the app
const apolloProvider = createApolloProvider({
  clients: {
    myPatients: transSericeApolloClient,
    myCalendar: transSericeApolloClient,
  },
  defaultClient: transSericeApolloClient,
})
app.use(apolloProvider)

// Initialize Userpilot
Userpilot.initialize('NX-a73cf339');

app.mount('#app')